angular.module('impactx.rfx').component('ixRfxSupplierHeader', {
        bindings: {
            rfqHeader: '<',
            contract: '<',
            trns: '<',
            deletePositions: '&',
            onChange: '&',
            selectedContracts: '=',
            selectedItems: '=',
            readOnly: "=",
            selectedConditions: '=',
            canAddProductPosition: "&",
            getProductSelectionParams: "&",
            canEdit: "&",
            markAsChangedFunc: "&",
            id: '=',
            dialogData: "="
        },
        controller: 'RFXSupplierHeaderCtrl',
        templateUrl: 'modules/rfxsupplier/templates/rfx-supplier-header.html'
    }
);